export default __webpack_public_path__ + "static/media/11.ccbdfee1.png";